import { estilosCKEditor, getClassePorEstilosDiferentes } from '../components/editor/ConfigurationCKEditor_old';
import UtilFormatacaoDocumento from '../misc/UtilFormatacaoDocumento';
import ParametroSistemaApi from '../api/ParametroSistemaApi';
import { b64EncodeUnicode, b64DecodeUnicode } from './Base64Utils';
import { TipoMinuta } from '../modelo/TipoMinuta';

const MARCADOR_DE_SV_TOPICO = 'data-sv-topico';
const MARCADOR_IDENTIFICACAO = "identificacao";
const MARCADOR_EMENTA = "ementa";
const MARCADOR_RELATORIO = "relatorio";
const MARCADOR_VOTO = "voto";
const MARCADOR_ACORDAO = "acordao";
const MARCADOR_CORPO = "corpo";
const MARCADOR_ASSINATURA = "assinatura";

const LIST_MARCADORES = {
   'identificao': MARCADOR_IDENTIFICACAO,
   'identificacao': MARCADOR_IDENTIFICACAO,
   'partes': MARCADOR_IDENTIFICACAO,
   'ementa': MARCADOR_EMENTA,
   'relatrio': MARCADOR_RELATORIO,
   'relatorio': MARCADOR_RELATORIO,
   'voto': MARCADOR_VOTO,
   'acordao': MARCADOR_ACORDAO,
   'istoposto': MARCADOR_ACORDAO,
   'despacho': MARCADOR_CORPO,
   'corpo': MARCADOR_CORPO,
   'assinatura': MARCADOR_ASSINATURA,
   'date': MARCADOR_ASSINATURA,
   'data': MARCADOR_ASSINATURA,
   'autoridade': MARCADOR_ASSINATURA,
   'ministro': MARCADOR_ASSINATURA,
   'funo': MARCADOR_ASSINATURA
};

const LIST_CLASSES = {
   'identificao': 'identificacao',
   'identificacao': 'identificao',
   'partes': 'partes',
   'ementa': 'ementa',
   'relatrio': 'relatorio',
   'relatorio': 'relatorio',
   'voto': 'voto',
   'acordao': 'acordao',
   'istoposto': 'istoposto',
   'despacho': 'despacho',
   'corpo': 'corpo',
   'assinatura': 'assinatura',
   'date': 'date',
   'data': 'data',
   'autoridade': 'autoridade',
   'ministro': 'ministro',
   'funo': 'funo',
   'funcao': 'funo',
   'num.processo': 'numprocesso',
   'numprocesso': 'numprocesso',
   'transcrio': 'transcricao',
   'transcrio2': 'transcricao2',
   'transcricao': 'transcricao',
   'transcricao2': 'transcricao2',
   'tema': 'tema'
};

const LIST_TRANSCRICAO = {

   'transcrio': 'transcricao',
   'transcrio2': 'transcricao2',
   'transcricao': 'transcricao',
   'transcricao2': 'transcricao2',
}

const LIST_EXISTENOTOPICO = {
   'identificacao': [MARCADOR_IDENTIFICACAO, MARCADOR_CORPO],
   'ementa': [MARCADOR_EMENTA, MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'corpo': [MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'relatrio': [MARCADOR_RELATORIO, MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'relatorio': [MARCADOR_RELATORIO, MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'voto': [MARCADOR_VOTO, MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'acordao': [MARCADOR_ACORDAO, MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'istoposto': [MARCADOR_ACORDAO, MARCADOR_CORPO, 'transcrio', 'transcrio2', 'transcricao', 'transcricao2'],
   'assinatura': [MARCADOR_ASSINATURA, MARCADOR_CORPO]
}

const TIRAR_DISPLAY_LIST = {
   'ementa': true,
   'voto': true,
   'istoposto': true
};

export function sistemaIncompativelComWord() {
    const wordIncompatibleOSList = [
        'Win16',
        'Windows 95',
        'Win95',
        'Windows_95',
        'Windows 98',
        'Win98',
        'Windows NT 5.0',
        'Windows 2000',
        'Windows NT 5.1',
        'Windows XP',
        'Windows NT 5.2',
        'Windows NT 6.0',
        'Windows NT 6.1',
        'Windows NT 6.2',
        'Windows 8',
    ];

    return wordIncompatibleOSList.reduce(
        (accumulator, currentValue) =>
            accumulator || navigator.userAgent.indexOf(currentValue) != -1,
        false
    );
}

export default class MinutaUtils {

   static retiraTagSemConteudo(conteudoMinuta, tagName) {
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;
      let i = 0;
      do {

         const tag = html.getElementsByTagName(tagName)[i];
         if (tag && tag.innerText.trim().length === 0 && !tag.parentNode.getAttribute(MARCADOR_DE_SV_TOPICO)) {
            tag.parentNode.removeChild(tag)
         } else {
            i++;
         }
      } while (i < html.getElementsByTagName(tagName).length)

      return html.innerHTML;
   }

   static retiraPForaDeMarcadorSvTopico(conteudoMinuta) {
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;
      let i = 0;
      do {

         const tag = html.getElementsByTagName('p')[i];
         if (!tag.getAttribute(MARCADOR_DE_SV_TOPICO)) {
            tag.parentNode.removeChild(tag)
         } else {
            i++;
         }
      } while (i < html.getElementsByTagName('p').length)

      return html.innerHTML;
   }

   static retiraTagASemClasse(conteudoMinuta) {
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;
      let i = 0;
      do {
         const a = html.getElementsByTagName('a')[i];
         if (a && !a.getAttribute('class')) {
            while (a.childElementCount > 0) {
               a.parentNode.insertBefore(a.children[0], a);
            }
            a.parentNode.removeChild(a);
         } else {
            i++;
         }
      } while (i < html.getElementsByTagName('a').length)

      return html.innerHTML;
   }

   static arrumaEstilos(conteudoMinuta) {
      conteudoMinuta = this.retiraTagASemClasse(conteudoMinuta);
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;
      let i = 0;
      let assinatura = false;
      const regExAssinatura = new RegExp('Brasília,.*de.+de');
      for (i = 0; i < html.getElementsByTagName('p').length; i++) {
         const p = html.getElementsByTagName('p')[i];
         const classes = p.getAttribute('class')?.toLowerCase().split(' ');
         if (!classes) {
            continue;
         }
         let classe = classes.find(c => { return LIST_CLASSES[c] }) as any;
         if (estilosCKEditor[classe]) {
            const estilo = p.getAttribute('style');
            if (estilosCKEditor[classe] !== estilo && getClassePorEstilosDiferentes[estilo]) {
               classe = getClassePorEstilosDiferentes[estilo];
               if (assinatura || (classe === 'corpo' && regExAssinatura.test(p.innerText))) {
                  assinatura = true;
                  classe = 'assinatura';
               }
            }
            p.setAttribute('style', estilosCKEditor[classe]);
            p.setAttribute('class', classe)
         } else {
            let svTopico = p.getAttribute(MARCADOR_DE_SV_TOPICO);
            if (!svTopico) {
               if (classe) {
                  svTopico = LIST_MARCADORES[classe.toLowerCase()];
                  svTopico && p.setAttribute(MARCADOR_DE_SV_TOPICO, svTopico);
               }
            }
            let stylesHtml: HTMLCollectionOf<HTMLStyleElement> = html.getElementsByTagName('style');
            if (stylesHtml?.length > 0) {
               stylesHtml = stylesHtml[0].innerText.split('\n.') as any;
               const estilo = (stylesHtml as any).find((estilo, index) => {
                  return index !== 0 && estilo.toLowerCase().indexOf(classe) > -1;
               });
               estilo && p.setAttribute('style', estilo.substring(estilo.indexOf('{') + 1, estilo.indexOf('}') - 1));
            } else {
               svTopico && p.setAttribute('style', estilosCKEditor[svTopico.toLowerCase()]);
            }
         }
      }
      html.innerHTML = this.arrumaTagsLi(html);
      return html.innerHTML;
   }

   static arrumaTagsLi(html) {
      const lis = html.getElementsByTagName('li');
      this.arrumaEstilosLis(lis);
      this.agrupaEmUls(html);
      return html.innerHTML;
   }

   static arrumaEstilosLis(lis) {
      let i = 0;
      while (i < lis.length) {
         const li = lis[i];
         const classes = li.getAttribute('class').split(' ');
         if (classes.some(classe => TIRAR_DISPLAY_LIST[classe.toLowerCase()])) {
            li.setAttribute('style', li.getAttribute('style').replace('display: list-item;', ''));
            const p = document.createElement('p');
            p.innerHTML = li.innerHTML;
            p.setAttribute('class', li.getAttribute('class'));
            p.setAttribute('style', li.getAttribute('style'));
            li.outerHTML = p.outerHTML;
         } else {
            li.setAttribute('style', li.getAttribute('style') + 'text-indent:inherit;');
            i++;
         }
      }
   }

   static agrupaEmUls(html) {
      const lis = html.getElementsByTagName('li');
      const uls = html.getElementsByTagName('ul');
      for (let i = 0; i < lis.length; i++) {
         const li = lis[i];
         let parent;

         for (const ul of uls) {
            if (ul.contains(li)) {
               parent = ul;
               break;
            }
         }
         if (li.previousSibling.tagName.toLowerCase() === 'ul'
            && li.getAttribute('class') === li.previousSibling.getAttribute('class')) {
            li.previousSibling.appendChild(li);
         } else if ((!parent && li.previousSibling.tagName.toLowerCase() !== 'ul')
            || (li.previousSibling.tagName.toLowerCase() === 'ul' && li.getAttribute('class') !== li.previousSibling.getAttribute('class'))) {
            const ul = document.createElement('ul');
            ul.setAttribute('style', 'padding-left:127.55pt;text-indent:0;');
            ul.setAttribute('class', li.getAttribute('class'));
            li.parentNode.insertBefore(ul, li);
            ul.appendChild(li);
         } else {
            console.error('o que fazer?', li);
         }
      }
   }

   static colocarDivDataSvTopico(conteudoMinuta) {

      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;
      const i = 0;
      const divExt = document.createElement('div');
      const allChildren = html.getElementsByTagName('div')[0].children;
      do {
         let svTopicoE1;
         let e1 = allChildren[i];
         const e2 = allChildren[i + 1];
         let divDataSv;
         if (e1.getAttribute('data-sv')) {
            e1 = e1.children[0];
            divDataSv = e1.parentNode;
         } else if ((e1.parentNode as any).getAttribute('data-sv')) {
            divDataSv = e1.parentNode;
         } else {
            divDataSv = document.createElement('div');
            divDataSv.setAttribute('data-sv', 'true');
            e1.parentNode.insertBefore(divDataSv, e1);
            divDataSv.appendChild(e1);
         }

         const classesE1 = e1.getAttribute('class') ? e1.getAttribute('class').toLowerCase().split(' ') : [];
         const classesE2 = e2 && e2.getAttribute('class') ? e2.getAttribute('class').toLowerCase().split(' ') : undefined;

         if (e1.getAttribute(MARCADOR_DE_SV_TOPICO)) {
            svTopicoE1 = e1.getAttribute(MARCADOR_DE_SV_TOPICO);
         } else if (LIST_MARCADORES[classesE1[0]]) {
            svTopicoE1 = LIST_MARCADORES[classesE1[0]];
            e1.setAttribute(MARCADOR_DE_SV_TOPICO, svTopicoE1);
         } else if (LIST_TRANSCRICAO[classesE1[0]]) {
            svTopicoE1 = e1.parentNode.childElementCount > 1 ? e1.parentNode.children[0].getAttribute(MARCADOR_DE_SV_TOPICO) : undefined;
         } else if ((e1 as any).innerText.trim().length > 0) {
            svTopicoE1 = "undefined";
            e1.setAttribute(MARCADOR_DE_SV_TOPICO, svTopicoE1);
         }

         if (e2) {
            let svTopicoE2 = undefined;
            let deveMudarDiv;
            if (svTopicoE1 && (svTopicoE1 === MARCADOR_IDENTIFICACAO && (e2 as any).innerText.trim() === 'D E S P A C H O')) {
               deveMudarDiv = true;
            } else if (svTopicoE1) {
               deveMudarDiv = !(LIST_EXISTENOTOPICO[svTopicoE1] && LIST_EXISTENOTOPICO[svTopicoE1].find(marcador => {
                  return LIST_MARCADORES[classesE2[0]] ? marcador === LIST_MARCADORES[classesE2[0]] : marcador === classesE2[0];
               }));
            }

            if (!deveMudarDiv) {
               svTopicoE2 = svTopicoE1;
               e2.setAttribute(MARCADOR_DE_SV_TOPICO, svTopicoE2);
               divDataSv.appendChild(e2);
               // i++;
            } else {
               divExt.appendChild(divDataSv);
               // i = i - (divDataSv.children.length - 1);
            }

         } else {
            divExt.appendChild(divDataSv);
            break;
         }

      } while (i < allChildren.length);

      return divExt.innerHTML;
   }

   static retirarPsSemTopico(conteudoMinuta) {
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;

      const divDataSv = html.getElementsByTagName('div');
      let i = 0;
      do {
         if (divDataSv[i].getAttribute('data-sv')) {
            const ps = divDataSv[i].getElementsByTagName('p');
            let j = 0;
            do {
               if (!ps[j].getAttribute(MARCADOR_DE_SV_TOPICO)) {
                  ps[j].parentNode.removeChild(ps[j]);
               } else {
                  j++;
               }
            } while (j < ps.length);
            if (divDataSv[i].innerText.trim().length === 0) {
               divDataSv[i].parentNode.removeChild(divDataSv[i]);
            } else {
               i++;
            }
         } else {
            i++;
         }
      } while (i < divDataSv.length);
      return html.innerHTML;
   }

   static retirarTopicosAnterioresAIdentificacao(conteudoMinuta) {
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;

      const divDataSv = html.getElementsByTagName('div');
      let i = 0;
      do {
         if (divDataSv[i].getElementsByTagName('p')[0] && divDataSv[i].getElementsByTagName('p')[0].getAttribute(MARCADOR_DE_SV_TOPICO) === MARCADOR_IDENTIFICACAO) {
            if (i >= 1) {
               divDataSv[i].parentNode.removeChild(divDataSv[i - 1]);
               i--;
            } else {
               return html.innerHTML;
            }
         } else {
            i++;
         }
      } while (i < divDataSv.length);
      return html.innerHTML;
   }

   static decodeMinuta(conteudo64) {
      let conteudo = conteudo64;
      const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
      let ehBase64 = base64Regex.test(conteudo);
      while (ehBase64 && conteudo.length !== 0) {
         conteudo = b64DecodeUnicode(conteudo);
         ehBase64 = base64Regex.test(conteudo)
      }
      return conteudo;
   }

   static encodeMinuta(minuta) {
      return minuta.tipoDocumentoMinuta === "docx" ? btoa(minuta.conteudo) : b64EncodeUnicode(minuta.conteudo);
   }

   static verificarMinutaInvalida(html, tipo) {
      const tipoCodigo = tipo && tipo.codigo ? tipo.codigo : tipo;
      const conteudo = this.decodeMinuta(html);
      let minutaComTopicosCorretos = {
         minutaValida: false,
         msgTopicos: ''
      };
      const topicosEncontrados = [];
      let marcadorIdentificacao;
      let marcadorEmenta;
      let marcadorRelatorio;
      let marcadorCorpo;
      let marcadorVoto;
      let marcadorAcordao;
      let marcadorAssinatura;

      if (tipoCodigo === TipoMinuta.VOTO) {
         marcadorIdentificacao = this.fimMarcador(conteudo, MARCADOR_IDENTIFICACAO);
         marcadorEmenta = this.fimMarcador(conteudo, MARCADOR_EMENTA);
         marcadorRelatorio = this.fimMarcador(conteudo, MARCADOR_RELATORIO);
         marcadorVoto = this.fimMarcador(conteudo, MARCADOR_VOTO);
         marcadorAcordao = this.fimMarcador(conteudo, MARCADOR_ACORDAO);
         marcadorAssinatura = this.fimMarcador(conteudo, MARCADOR_ASSINATURA);

         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_IDENTIFICACAO, marcadorIdentificacao);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_EMENTA, marcadorEmenta);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_RELATORIO, marcadorRelatorio);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_VOTO, marcadorVoto);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_ACORDAO, marcadorAcordao);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_ASSINATURA, marcadorAssinatura);

         if (marcadorIdentificacao < marcadorEmenta
            && marcadorEmenta < marcadorRelatorio
            && marcadorRelatorio < marcadorVoto
            && marcadorVoto < marcadorAcordao
            && marcadorAcordao < marcadorAssinatura
            && topicosEncontrados.length === 6) {

            minutaComTopicosCorretos.minutaValida = true;
         } else {
            minutaComTopicosCorretos.msgTopicos = 'A ordem dos tópicos encontrados não está correta. ';
         }
      } else {
         marcadorIdentificacao = this.fimMarcador(conteudo, MARCADOR_IDENTIFICACAO);
         marcadorCorpo = this.fimMarcador(conteudo, MARCADOR_CORPO);
         marcadorAssinatura = this.fimMarcador(conteudo, MARCADOR_ASSINATURA);

         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_IDENTIFICACAO, marcadorIdentificacao);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_CORPO, marcadorCorpo);
         this.adicionarTopicoSeEncontrado(topicosEncontrados, MARCADOR_ASSINATURA, marcadorAssinatura);

         if (marcadorIdentificacao < marcadorCorpo
            && marcadorIdentificacao < marcadorAssinatura
            && topicosEncontrados.length === 3) {

            minutaComTopicosCorretos.minutaValida = true;
         } else {
            minutaComTopicosCorretos.msgTopicos = 'A ordem dos tópicos encontrados não está correta. ';
         }
      }

      const mensagem = this.verificaTopicosUndefined(html) + this.verificarProblemaNosTopicos(topicosEncontrados, tipoCodigo);
      if (mensagem) {
         minutaComTopicosCorretos = {
            minutaValida: false,
            msgTopicos: mensagem + minutaComTopicosCorretos.msgTopicos
         }
      }
      return minutaComTopicosCorretos;
   }

   static fimMarcador = (modelo, marcador) => {
      const indexUltimoMarcador = modelo.lastIndexOf(MARCADOR_DE_SV_TOPICO + '="' + marcador + '"');
      return indexUltimoMarcador < 0 ?
         -1
         :
         (indexUltimoMarcador
            + modelo.substring(indexUltimoMarcador).indexOf("</div>")
         );
   }

   static adicionarTopicoSeEncontrado = (mapEncontrados, topico, posicao) => {
      if (posicao > 0) {
         mapEncontrados.push({ topico: topico, posicao: posicao });
      }
   }

   static verificaTopicosUndefined = (stringHtml) => {
      let mensagem = '';
      const div = document.createElement('div');
      div.innerHTML = stringHtml;
      const divDataSvTopico = div.getElementsByTagName('p');
      for (let i = 0; i < divDataSvTopico.length; i++) {
         const topico = divDataSvTopico[i].getAttribute('data-sv-topico');
         if (!topico || topico === 'undefined' || topico === 'desconhecido') {
            mensagem = 'Existem paragrafos com tópicos não identificados.';
            break;
         }
      }
      return mensagem;
   }

   static verificarProblemaNosTopicos(topicosEncontrados, tipo) {
      const topicosOrdenados = topicosEncontrados.sort((a, b) => {
         if (a.posicao > b.posicao) {
            return 1;
         }
         if (a.naposicaome < b.posicao) {
            return -1;
         }
         return 0;
      });
      let mensagem = '';
      const topicosFaltando = [];
      let topicosNecessarios = [];

      if (tipo === TipoMinuta.VOTO) {
         topicosNecessarios = [MARCADOR_IDENTIFICACAO, MARCADOR_EMENTA, MARCADOR_RELATORIO, MARCADOR_VOTO, MARCADOR_ACORDAO, MARCADOR_ASSINATURA];
      } else {
         topicosNecessarios = [MARCADOR_IDENTIFICACAO, MARCADOR_CORPO, MARCADOR_ASSINATURA];
      }

      let encontrado;
      topicosNecessarios.forEach(topicoNecessario => {
         encontrado = topicosOrdenados.some(topicoExistente => {
            return topicoExistente.topico.indexOf(topicoNecessario) > -1;
         });
         if (!encontrado) {
            topicosFaltando.push(topicoNecessario);
         }
      });

      if (!encontrado) {
         mensagem = 'Não foram encontrados os seguintes tópicos:' + topicosFaltando.join(' ');
      }

      return mensagem;
   }

   static refazerAssinaturaVazia(conteudoMinuta, nomeMinistro, funcaoMinistro) {
      const html = document.createElement('div');
      html.innerHTML = conteudoMinuta;
      let divSvs = html.getElementsByTagName('div');
      for (let i = 0; i < divSvs.length; i++) {
         if ((divSvs as any).getAttribute(MARCADOR_DE_SV_TOPICO) === MARCADOR_ASSINATURA) {
            divSvs = this.novaDivAssinatura(nomeMinistro, funcaoMinistro) as any;
            break;
         }
      }
      return (divSvs as any).innerHTML.replace(/\r/g, '').replace(/↵/g, '');
   }

   static codificarHtml(texto) {
      const htmlCodigo = {
         'á': { 'code': '&aacute;' },
         'Á': { 'code': '&Aacute;' },
         'ã': { 'code': '&atilde;' },
         'Ã': { 'code': '&Atilde;' },
         'à': { 'code': '&agrave;' },
         'À': { 'code': '&Agrave;' },
         'é': { 'code': '&eacute;' },
         'É': { 'code': '&Eacute;' },
         'í': { 'code': '&iacute;' },
         'Í': { 'code': '&Iacute;' },
         'ó': { 'code': '&oacute;' },
         'Ó': { 'code ': '&Oacute;' },
         'õ': { 'code': '&otilde;' },
         'Õ': { 'code': '&Otilde;' },
         'ú': { 'code': '&uacute;' },
         'Ú': { 'code': '&Uacute;' },
         'ç': { 'code': '&ccedil;' },
         'Ç': { 'code': '&Ccedil;' }
      };
      const acentos = ['á', 'Á', 'ã', 'Ã', 'à', 'À', 'é', 'É', 'í', 'Í', 'ó', 'Ó', 'õ', 'Õ', 'ú', 'Ú', 'ç', 'Ç'];

      for (let i = 0; i < acentos.length; i++) {
         if (htmlCodigo[acentos[i]] != undefined) {
            texto = texto.replace(new RegExp(acentos[i], 'g'), htmlCodigo[acentos[i]].code);
         }
      }

      return texto;
   }

   static novaDivAssinatura(nomeMinistro, funcaoMinistro) {

      return (`
         <div data-sv="true">
            <p class="date" style="mso-style-name: Data; mso-style-link: Data Char; margin: 0cm; margin-bottom: .0001pt; text-align: justify; text-justify: inter-ideograph;text-indent: 127.6pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family:Courier;color: fuchsia;" data-sv-topico="assinatura">
               <span class="DefaultParagraphFont " style=""><span class="" style="">
                  Bras&iacute;lia,   de         de
               </span>
               </span>
               <span class="DefaultParagraphFont " style="">
               </span>
            </p>
            <p class="corpo" style="mso-style-name: Corpo;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;" data-sv-topico="assinatura">
               <span class="DefaultParagraphFont " style="">
               </span>
            </p>
            <p class="corpo" style="mso-style-name: Corpo;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;" data-sv-topico="assinatura">
               <span class="DefaultParagraphFont " style="">
               </span>
            </p>
            <p class="corpo" style="mso-style-name: Corpo;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;" data-sv-topico="assinatura">
               <span class="DefaultParagraphFont " style="font-weight: bold;">
               </span>
            </p>
            <p class="autoridade" style="mso-style-name: Autoridade;margin-top: 0cm;margin-right: 93.55pt;margin-bottom: 0cm;margin-left: 93.55pt;text-align: center;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;text-transform: uppercase;font-weight: bold" data-sv-topico="assinatura">
            <span class="DefaultParagraphFont " style="">
               ${this.codificarHtml(nomeMinistro)}
            </span>
            </p >
            <p class="funo" style="mso-style-name: Função;margin-top: 0cm;margin-right: 93.55pt;margin-bottom: 0cm;margin-left: 93.55pt;text-align: center;line-height: 150%;text-autospace: none;font-size: 10.0pt;font-family: Courier;color: black;font-weight: bold" data-sv-topico="assinatura">
               <span class="DefaultParagraphFont " style="">
                  ${this.codificarHtml(funcaoMinistro)}
               </span>
            </p>
         </div >
      `);
   }
}
